//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectedFooter from './selected-footer.vue';
/**
 * @event selector-click - 点击选择器触发的事件
 */
/* eslint-disable */

/**
 * @noteType component
 * @name Select
 * @tagName mt-select
 * @desc 选择器
 * @wrapClassName mint-cell
 * @html
 * <mt-select label="标题文字"></mt-select>
 */
export default {
  name: 'mt-select',
  components: { SelectedFooter },
  props: {
    value: { default: '' },
    // url: { type: String, default: '' },

    /**
     * @noteType prop
     * @field label
     * @desc 标题
     * @type input
     * @value 标题
     */
    label: { type: String, required: true },
    /**
     * @noteType prop
     * @field placeholder
     * @desc 占位文本
     * @type input
     * @value 请选择
     */
    placeholder: { type: String, default: '请选择' },
    options: { type: Array, required: true },
    /**
     * @noteType prop
     * @field selectType
     * @desc 选择器类型
     * @type select
     * @option 
      [
        {
          "text": "自定义",
          "value": ""
        },
        {
          "text": "单选",
          "value": "select"
        },
        {
          "text": "多选",
          "value": "multi-select"
        }
      ]
     */
    selectType: { type: String, default: 'select' },
    iconpattern: { type: String, default: 'circle' },
    align: String,
    required: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    titlewidth: String,
    valueAlign: String
  },
  data() {
    return {
      selectorShow: false,
      cHeight: document.documentElement.clientHeight,
      isDefalut: true
    };
  },
  computed: {
    /***** select 专有属性 *****/
    currentValue: {
      get () {
        if (this.selectType === 'select') {
          return this.value;
        } else if (this.selectType === 'multi-select') {
          if (this.value === '') return []
          return this.value.split(',')
        } else {
          return this.value
        }
      }, 
      set (val) {
        if (this.selectType === 'select') {
          this.$emit('input', val.toString());
          history.back();
        } else if (this.selectType === 'multi-select') {
          this.$emit('input', val.join(','))
        } else {
          this.$emit('input', val)
        }
      }
    },
    /***** select 专有属性 end *****/
  },
  methods: {
    handleDisplayClick(e) {
      if(this.disabled||this.readonly) return;
      this.$emit('selector-click', this.selectType, this,e);
      history.pushState('', null, '#/smile-select');
      this.selectorShow = true;
    },
    historyChange(e) {
      this.selectorShow = false;
    },
    /***** select 专有方法 *****/
    getOptions_select (options) {
      if (!options || options.length === 0) {
        return []
      }
      return options.map(item => {
        return {
          value: item.id,
          label: item.name
        }
      })
    },
    singleSelectDisplay () {
      if (this.value === '' || this.value === null || this.value === undefined){
        this.isDefalut = true;
        return this.placeholder;
      }
      if (this.options.length === 0) {
        this.$emit('selector-click', '')
        return ''
      }
      // 解决 初始化设置的值在下拉列表中不存在 ，控制台报错(name "undefined")的问题 wangyongjian 2018-5-28
      var singleSelectValue = this.options.filter(item => {
        if (!item || item.id === null) return false
        return item.id.toString() === this.value.toString()
      });
      this.isDefalut = false;
      return singleSelectValue.length?singleSelectValue[0].name:this.value
    },
    handleClick_select(val, $event) {
      this.$emit('change', val, $event);
      this.selectorShow = false
    },
    /***** select 专有方法 end *****/

    /***** multi-select 专有方法 *****/
    multiSelectDisplay () {
      if (this.value === '') {
        this.isDefalut = true;
        return this.placeholder
      }
      if (this.options.length === 0) {
        this.$emit('selector-click', '')
        return ''
      }
      this.isDefalut = false;
      var multiSelectValue = this.options.filter(item => this.currentValue.indexOf(item.id.toString()) > -1).map(item => item.name).join(',');
      return  multiSelectValue.length?multiSelectValue:this.value;
    },
    handleClick_multiSelect (val, $event) {
      this.$emit('change', this.currentValue, $event)
    },
    confirm_multiSelect (){
      this.selectorShow = false;
      history.back();
    }
    /***** multi-select 专有方法 end *****/
  },
  mounted () {
    window.addEventListener("popstate", this.historyChange)
  },
  beforeDestroy () {
    window.removeEventListener("popstate", this.historyChange)
  }
};

/**
 * @noteType external
 * @content
  {
    "mock": {
    "selected": ""
  },
  "modelName": "selected",
  "xtype": [ "select", "multi-select", "multi-select2" ],
  "bindField": "v-model"
 }
 */



// WEBPACK FOOTER //
// ./packages/select/src/select.vue